export function PillSelect({ label, hint, options, value, onChange, testId, columns, error, disabled }) {
  const count = options.length;
  const useGrid = columns !== undefined ? columns > 0 : count > 3;
  const gridCols = columns || 2;

  return (
    <div style={{ position: "relative", marginBottom: 22 }}>
      {label && (
        <label className="block text-xs font-semibold text-we-text mb-1.5">
          {label}
        </label>
      )}
      <div
        data-testid={testId}
        style={{
          ...(useGrid
            ? { display: "grid", gridTemplateColumns: `repeat(${gridCols}, 1fr)`, gap: 6 }
            : { display: "flex", gap: 6 }),
          ...(error ? { borderRadius: 14, boxShadow: "0 0 0 2px rgba(192, 69, 58, 0.25)" } : {}),
        }}
      >
        {options.map((opt) => {
          const optLabel = typeof opt === "string" ? opt : opt.label;
          const optValue = typeof opt === "string" ? opt : opt.value;
          const isSelected = value === optValue;

          return (
            <button
              key={optValue}
              type="button"
              onClick={() => !disabled && onChange(optValue)}
              data-testid={`${testId}-${String(optValue).toLowerCase().replace(/[\s()\/]/g, "-")}`}
              className="transition-all duration-200 ease-in-out cursor-pointer text-[13px]"
              style={{
                padding: "10px 12px",
                borderRadius: 12,
                fontWeight: isSelected ? 600 : 400,
                border: isSelected
                  ? "2px solid #00628F"
                  : error && !isSelected
                    ? "1.5px solid #C0453A"
                    : "1.5px solid #E2D9CB",
                background: isSelected ? "#E3F0F5" : "transparent",
                color: isSelected ? "#00628F" : "#71644C",
                width: "100%",
                textAlign: "center",
                opacity: disabled ? 0.5 : 1,
                cursor: disabled ? "not-allowed" : "pointer",
              }}
            >
              {optLabel}
            </button>
          );
        })}
      </div>
      {hint && !error && (
        <p
          data-testid={testId ? `${testId}-hint` : undefined}
          className="text-[11px] text-[#71644C] mt-1.5 leading-snug"
        >
          {hint}
        </p>
      )}
      {error && (
        <p
          data-testid={`${testId}-error`}
          style={{
            position: "absolute",
            bottom: -14,
            left: 4,
            fontSize: 11,
            lineHeight: 1,
            color: "#C0453A",
            fontWeight: 500,
            zIndex: 1,
            pointerEvents: "none",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "calc(100% - 8px)",
          }}
        >
          {error}
        </p>
      )}
    </div>
  );
}
